/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Account_Privacy_DescriptionInputs */

const de_account_privacy_description = /** @type {(inputs: Account_Privacy_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hier finden Sie Informationen und Einstellungen zum Umgang mit Ihren personenbezogenen Daten bei waipu.tv.`)
};

/** @type {(inputs: Account_Privacy_DescriptionInputs) => LocalizedString} */
const en_account_privacy_description = de_account_privacy_description;

/**

* @param {Account_Privacy_DescriptionInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const account_privacy_description = /** @type {((inputs?: Account_Privacy_DescriptionInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Account_Privacy_DescriptionInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_account_privacy_description(inputs)
	return en_account_privacy_description(inputs)
});